import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import { Container, ImagesContainer } from "./styled.components";
import { Image } from "antd";
import { BACKEND_URL } from "../../constants/urls";
const Gallery = () => {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState();

  useEffect(() => {
    axios.get(`${BACKEND_URL}/gallery`).then((res) => {
      setData(res.data);
    });
  }, []);
  console.log(data);

  return (
    <>
      <Layout>
        <Hero
          title="Gallery"
          SubTitle="HHH and Sons Presents a Proud Past And Will  Keep The Promise For Days To Come"
        />
        <Container>
          <ImagesContainer>
            {console.log(data)}
            {data.images?.map((img_) => {
              return (
                <>
                  {/* <Image
                    preview={{ visible: false }}
                    width={300}
                    height={200}
                    src={`data:image/jpeg;base64,${img_?.encodedImg}`}
                    onClick={() => setVisible(true)}
                  /> */}
                  <Image.PreviewGroup
                    onClick={() => setVisible(true)}
                    preview={{
                      visible,
                      // onVisibleChange: (vis) => setVisible(vis),
                    }}
                  >
                    <Image src={img_?.path} />
                  </Image.PreviewGroup>
                </>
              );
            })}
          </ImagesContainer>
        </Container>
      </Layout>
    </>
  );
};

export default Gallery;
